export enum ErrorCode {
  InvalidCredentials = 'INVALID_CREDENTIALS',
  UserDeactivated = 'USER_DEACTIVATED',
  UserLogin = 'USER_LOGIN',
  SERVICE_DOESNT_EXISTS = 'SERVICE_DOESNT_EXISTS',
  TokenExpired = 'TOKEN_EXPIRED',
  OperatorProductStatusChangingException = 'OPERATOR_PRODUCT_STATUS_CHANGING_EXCEPTION',
  RefreshExpired = 'AUTH-00014',
  VendorProviderAssignFailed = 'AGGREGATOR_VENDOR_PROVIDER_ASSIGN_FAILED',
  SingleActiveProviderConstraint = 'SINGLE_ACTIVE_PROVIDER_CONSTRAINT',
  WorkspaceOwnerAlreadyActive = 'WORKSPACE_OWNER_ALREADY_ACTIVE',
  AggregatorRequestFailed = 'AGGREGATOR_REQUEST_FAILED',
  UserDeactivatedAuth = 'AUTH-00016',
  CannotChangeOwnStatus = 'CANNOT_CHANGE_USER_STATUS',
  CriticalScopesChange = 'AUTH-00004',
  DomainConfigurationEmpty = 'DOMAIN_CONFIGURATION_EMPTY',
  PaymentMethodBoNameDuplicate = 'PAYMENT_METHOD_BO_NAME_DUPLICATE',
  KycConstraintViolation = 'KYC_CONSTRAINT_VIOLATION',
  ForceUpdateNotificationsFailed = 'FORCE_UPDATE_NOTIFICATIONS_FAILED',
}
